import {
  Box,
  Link,
  Popover,
  SpaceBetween,
} from '@amzn/awsui-components-console';

export const FLC_PREVIEW_VERIFY_URL =
  'https://alpha.www.docs.aws.a2z.com/fusion/latest/userguide/flc-using-flc.html#flc-preview-verify';

/**
 * Info popover shown beside the Preview button. Explains the venue-build
 * propagation wait and how to construct a deep-link preview URL for a specific
 * page, and links to the Fusion User Guide. Kept as a single shared component so
 * the guidance stays identical next to every Preview button.
 */
export const PreviewGuidance = () => (
  <Popover
    header='About the preview'
    position='top'
    size='large'
    triggerType='text'
    content={
      <SpaceBetween size='s'>
        <Box variant='p'>
          After a launch reaches <b>Ready for Review</b>, the venue build needs
          about <b>15&ndash;30 minutes</b> to propagate before the preview
          serves your pages. If the preview returns a 404 or shows stale
          content, wait a few minutes and refresh.
        </Box>
        <Box variant='p'>
          The <b>Preview</b> button opens the venue preview root. To open a
          specific page, append the doc path to that URL:
        </Box>
        <Box variant='code'>
          {'{preview-root}/{docset}/{version}/{guide}/{topic}.html'}
        </Box>
        <Box variant='p'>
          See{' '}
          <Link external href={FLC_PREVIEW_VERIFY_URL}>
            Preview and verify content
          </Link>{' '}
          in the <i>Fusion User Guide</i>.
        </Box>
      </SpaceBetween>
    }
  >
    <Link variant='info'>Info</Link>
  </Popover>
);
